import React, { useState } from "react";
import axios from "axios";
import styles from "./Team.module.css";
import SideBar from "../SideBar/SideBar";
import Games from "../Games/Games";

const Team = ({ isAdmin, serverIP }) => {
    const [currentView, setCurrentView] = useState("create");
    const [teams, setTeams] = useState([]);
    const [teamName, setTeamName] = useState("");
    const [teamLogin, setTeamLogin] = useState("");
    const [teamPassword, setTeamPassword] = useState("");
    const [teamGame, setTeamGame] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedScenario, setSelectedScenario] = useState(1);

    const handleCreateTeam = async (serverIP) => {
        if (!teamName || !teamLogin || !teamPassword || !teamGame) {
            alert("Заполните все поля!");
            return;
        }

        const teamData = {
            name: teamName,
            login: teamLogin,
            password: teamPassword,
            game: teamGame,
            scenario_id: selectedScenario,
        };

        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(
                `${serverIP}/v1/team/new`,
                teamData,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    }
                }
            );

            alert("Команда успешно создана!");
            setTeams(prev => [...prev, response.data]);
            setTeamName("");
            setTeamLogin("");
            setTeamPassword("");
            setTeamGame("");
        } catch (err) {
            if (err.response) {
                const errorData = err.response.data;
                if (errorData.code === 400 && errorData.message === "Already exists") {
                    alert("Ошибка: команда с таким логином уже существует!");
                } else {
                    alert(`Ошибка создания команды: ${errorData.message || 'Неизвестная ошибка'}`);
                }
            } else if (err.request) {
                alert("Ошибка при соединении с сервером");
            } else {
                alert("Произошла ошибка при отправке запроса");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <SideBar
                position={{ position: "relative", marginTop: 20 }}
                blueTeam={{ backgroundColor: "#0170ba", color: "#fff" }}
                isAdmin={isAdmin}
            />
            <div className={styles.adminPage}>
                <nav className={styles.nav}>
                    <span
                        onClick={() => setCurrentView("create")}
                        className={currentView === "create" ? styles.select : styles.normal}
                    >
                        Создание команды
                    </span>
                    <span
                        onClick={() => setCurrentView("view")}
                        className={currentView === "view" ? styles.select : styles.normal}
                    >
                        Список команд
                    </span>
                </nav>

                {currentView === "create" ? (
                    <div className={styles.createTeam}>
                        <div className={styles.inputLogreg}>
                            <label htmlFor="team-name">Название команды</label>
                            <input
                                type="text"
                                id="team-name"
                                placeholder="Введите название команды"
                                required
                                value={teamName}
                                onChange={(e) => setTeamName(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputLogreg}>
                            <label htmlFor="team-login">Логин</label>
                            <input
                                type="text"
                                id="team-login"
                                placeholder="Введите логин"
                                required
                                value={teamLogin}
                                onChange={(e) => setTeamLogin(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputLogreg}>
                            <label htmlFor="team-password">Пароль</label>
                            <input
                                type="password"
                                id="team-password"
                                placeholder="Введите пароль"
                                required
                                value={teamPassword}
                                onChange={(e) => setTeamPassword(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputLogreg}>
                            <label htmlFor="team-game">Название игры</label>
                            <input
                                type="text"
                                id="team-game"
                                placeholder="Введите Название игры для группировки команд"
                                required
                                value={teamGame}
                                onChange={(e) => setTeamGame(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputLogreg}>
                            <label htmlFor="team-scenario">Сценарий</label>
                            <select
                                id="team-scenario"
                                value={selectedScenario}
                                onChange={(e) => setSelectedScenario(Number(e.target.value))}
                            >
                                <option value={1}>Базовый</option>
                                <option value={2}>Сахалин</option>
                            </select>
                        </div>
                        <button
                            onClick={() => handleCreateTeam(serverIP)}
                            className={styles.loginButton}
                            disabled={loading}
                        >
                            {loading ? "Создание..." : "Создать команду"}
                        </button>
                        {error && <p className={styles.error}>{error}</p>}
                    </div>
                ) : (
                    <div className={styles.viewTeams}>
                        <Games
                            isAdmin={isAdmin}
                            serverIP={serverIP}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default Team;